import React from 'react';
import { Page } from '../Page';
import { HeartPulse, Footprints, Smile, Zap } from 'lucide-react';
export function Page10() {
  return <Page pageNumber={26} variant="light" data-id="element-704" data-mp="2tzltsqg1sj58">
      <div className="flex flex-col h-full" data-id="element-705" data-mp="2g0mggexzjqod">
        {/* Hero Image Header */}
        <div className="relative h-[380px] -mx-12 -mt-10 mb-10 overflow-hidden" data-id="element-706" data-mp="2g2p3qr7r75pe">
          <img src="https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=1000&q=80" alt="Cardio running" className="w-full h-full object-cover" data-id="element-707" data-mp="2k04q2ekcwfbw" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/60 to-transparent" data-id="element-708" data-mp="2b2kmv02xo8yn" />

          <div className="absolute bottom-0 left-12 right-12 pb-6" data-id="element-709" data-mp="1waagc5vc36vv">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-710" data-mp="21c8154jdu9qx">
              The Essentials
            </p>
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight" data-id="element-711" data-mp="1sas3zyhkw44n">
              Cardiovascular <span className="text-tealslate" data-id="element-712" data-mp="1scl0ikyh97yx">Health</span>
            </h1>
          </div>
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-8 max-w-2xl" data-id="element-713" data-mp="3ikzbato5pbj1">
          While weight lifting protects your metabolism and muscle mass, cardio
          protects your heart and improves your stamina. You need both, but they
          serve different purposes.
        </p>

        <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6 text-center mb-10" data-id="element-714" data-mp="3rjugc2fgsfkr">
          <h2 className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-715" data-mp="33wcjhshcerax">
            The Goal
          </h2>
          <div className="text-3xl font-serif text-[#1F1F1F] mb-2" data-id="element-716" data-mp="3dlmbz9g3mbzk">
            150 Minutes Per Week
          </div>
          <p className="text-xs text-[#7A7A70] leading-[1.8] max-w-md mx-auto" data-id="element-717" data-mp="38unwud6ujjxw">
            Aim for a pace where singing is hard and talking takes effort. Brisk
            walking, jogging, or dancing all count.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-6 mb-10" data-id="element-718" data-mp="2g68gnnbzavkz">
          <div className="flex flex-col items-center text-center" data-id="element-719" data-mp="k3vobshocv5z">
            <HeartPulse className="w-8 h-8 text-tealslate mb-3" data-id="element-720" data-mp="k1j5ld43egrv" />
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-1" data-id="element-721" data-mp="p0vsfxuyrnug">
              Heart Health
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-722" data-mp="ttynybjax7da">
              Strengthens your cardiovascular system.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-723" data-mp="159la82lktzf">
            <Smile className="w-8 h-8 text-tealslate mb-3" data-id="element-724" data-mp="16ucpotm7wt2" />
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-1" data-id="element-725" data-mp="644du1qd9wwq">
              Mood Boost
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-726" data-mp="a3uzjr11dmue">
              Releases endorphins and reduces stress.
            </p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-727" data-mp="1lkurgljh1znw">
            <Zap className="w-8 h-8 text-tealslate mb-3" data-id="element-728" data-mp="1lmpb7wj0blqe" />
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-1" data-id="element-729" data-mp="1qi4nik1d99kp">
              More Energy
            </h3>
            <p className="text-[10px] text-[#7A7A70] leading-[1.6]" data-id="element-730" data-mp="20mux9c30hhzh">
              Builds stamina for everyday activities.
            </p>
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-end space-y-4" data-id="element-731" data-mp="1qwrr0a6vq7j7">
          <div className="flex items-start gap-4 border-t border-[#D8D8D0] pt-6" data-id="element-732" data-mp="1mvy3hhxcmuqu">
            <Footprints className="w-6 h-6 text-tealslate shrink-0 mt-1" data-id="element-733" data-mp="1mu584ys6rwy5" />
            <div data-id="element-734" data-mp="1hyg4aj94vtw1">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-735" data-mp="1husark3ov7hb">
                Start Simple
              </h3>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-736" data-mp="17ypaykwb7kxj">
                Any movement is better than none. Once you start, it gets easier
                to build from there.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4" data-id="element-737" data-mp="32bov8rbmx3b5">
            <div className="w-6 h-6 rounded-full bg-tealslate text-white flex items-center justify-center font-bold shrink-0 mt-1 text-sm" data-id="element-738" data-mp="32adt0vxu83m5">
              !
            </div>
            <div data-id="element-739" data-mp="35eurf99ge41w">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-740" data-mp="35c8knbudzskq">
                The 10-Minute Rule
              </h3>
              <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-741" data-mp="2wdwtn8plysrr">
                Start with walking if you're new to exercise. Even 10-minute
                walks after meals can make a significant difference for blood
                sugar control.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}